"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:5.1.3'] && _();
}
catch (e) { }
